import { v4 as uuid_v4 } from "uuid";
import { Skeleton, Stack } from "@mui/material";
import { CompensationDataRecord } from "./types";

function guessRowColor(row: CompensationDataRecord, index: number) {
	const strippedColor = index % 2 !== 0 ? "white" : undefined;
	return row.item?.toUpperCase() === "COMMISSION SUBTOTAL" ? "#b3b3b3" : strippedColor;
}

export function CompensationLoadingOverlay({
	rows,
	defaultRowHeight,
}: Readonly<{ rows: CompensationDataRecord[]; defaultRowHeight: number }>) {
	return (
		<Stack className="w-full bg-white">
			{rows.map((row, index) => (
				<Skeleton
					key={`skeleton-${row.item}-${uuid_v4()}`}
					variant="rectangular"
					height={row.item?.toUpperCase() === "CIT BONUS" ? "auto" : defaultRowHeight}
					width="100%"
					sx={{
						backgroundColor: guessRowColor(row, index),
					}}
				/>
			))}
			<Skeleton variant="rectangular" height={defaultRowHeight} width="100%" sx={{ backgroundColor: "var(--primary-color)" }} />
		</Stack>
	);
}
